<template>
  <div class="ps-page">
    <div class="ps-page__title">Produkte &amp; Fulfillment</div>
    <PrintVariants />
    <SkuMapping />
    <ProductTypes />
    <PrintShops />
  </div>
</template>

<script>
import PrintShops from "@/components/Settings/Products/PrintShops/PrintShops";
import SkuMapping from "@/components/Settings/Products/SkuMappings/SkuMappings";
import ProductTypes from "@/components/Settings/Products/ProductTypes/ProductTypes";
import PrintVariants from "@/components/Settings/Products/PrintVariants/PrintVariants";
export default {
  name: "AdminProducts",
  components: { PrintVariants, ProductTypes, SkuMapping, PrintShops },
};
</script>

<style scoped></style>
